module.exports = __webpack_public_path__ + "img/payment-history.ddab7bc7.jpg";